import { TypeBaggage } from "@/lib/redux/features/flight/type"

const VJ_AIRLINE = "VJ"

export function getBaggageDisplayLabel(
  baggage: Pick<TypeBaggage, "airline" | "value" | "name" | "description">
): string {
  const name = (baggage.name || "").trim()
  const combined = `${baggage.value || ""} ${name} ${baggage.description || ""}`

  if (
    baggage.airline === VJ_AIRLINE &&
    /oversize/i.test(combined) &&
    name
  ) {
    return name
  }

  const source = combined.toUpperCase()
  const m = source.match(/\d+\s*KGS?/)?.[0]
  if (m) return m.replace(/\s+/g, "").replace(/KGS/gi, "KG")
  const v = (baggage.value || "").trim()
  const n = (baggage.name || "").trim()
  const d = (baggage.description || "").trim()
  if (v.toUpperCase() === "BG") return n || d || v
  return v || n || d
}
